import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchGetClubImages, fetchGetHallsGallery } from "./asyncActions";
import { IImagesState, IClubImage, IHallGalleryItem } from "./types";

const initialState: IImagesState = {
  isLoading: false,
  clubImages: [],
  hallsGallery: [],
};

const imagesSlice = createSlice({
  name: "images",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getClubImages
    builder.addCase(fetchGetClubImages.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      fetchGetClubImages.fulfilled,
      (state, action: PayloadAction<IClubImage[]>) => {
        state.isLoading = false;
        state.clubImages = action.payload;
      }
    );
    builder.addCase(fetchGetClubImages.rejected, (state) => {
      state.isLoading = false;
    });

    // getHallsGallery
    builder.addCase(fetchGetHallsGallery.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      fetchGetHallsGallery.fulfilled,
      (state, action: PayloadAction<IHallGalleryItem[]>) => {
        state.isLoading = false;
        state.hallsGallery = action.payload;
      }
    );
    builder.addCase(fetchGetHallsGallery.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default imagesSlice.reducer;
